import { Component, h } from 'preact'
import Header from '../header'
import { GroupData, HeroImageData } from './Overview'
import Axios from 'axios'
import AlertComponent from '../ui-components/AlertComponent'
import GroupInfoPanel from './GroupInfoPanel'

interface Props {}

interface State extends GroupData {
  src: null | string,
  crop: {
    x: number,
    y: number,
    width: number,
    height: number,
    aspect: number
  },
  pixelCrop: {
    width: number,
    height: number,
    x: number,
    y:number
  },
  isLoading: boolean,
  messageType: null |'success'| 'error',
  titleError: string,
  descriptionError: string
}

export class GroupAdd extends Component<Props, State> {
  constructor () {
    super()

    this.state = {
      title: '',
      description: '',
      heroImage: null,
      src: null,
      crop: {
        x: 0,
        y: 0,
        width: 120,
        height: 60,
        aspect: 2
      },
      pixelCrop: {
        width: 120,
        height: 60,
        x: 0,
        y: 0
      },
      isLoading: false,
      messageType: null,
      titleError: '',
      descriptionError: ''
    }

    this.onSave = this.onSave.bind(this)
  }

  async onSave () {
    let errors: {
      title?: string,
      description?: string
    } = {}
    if (this.state.title === '') {
      errors.title = 'Please fill in this field'
    }

    if (this.state.description === '') {
      errors.description = 'Group description can’t be blank'
    }

    if (Object.keys(errors).length) {
      this.setState({
        titleError: errors.title || '',
        descriptionError: errors.description || ''
      })

      return
    }

    this.setState({ isLoading: true, messageType: null })
    try {
      const { data }: { data: { id: string } } = await Axios.post('/platform/group/add', {
        title: this.state.title,
        description: this.state.description,
        heroImage: this.state.heroImage
      })

      if (data.id) {
        window.location.assign(`/platform/group/${data.id}?success=true`)
      }
    } catch (err) {
      this.setState({
        isLoading: false,
        messageType: 'error'
      })
    }
  }

  render (_: Props, { title, description, heroImage, isLoading, messageType, titleError, descriptionError }: State) {
    return (
      <div className='group-add-page'>
        <Header
          title='Add group'
          isLoading={isLoading}
          saveCallback={this.onSave}
        />
        { messageType ? <AlertComponent sticky messageType={messageType} isVisibleFor={3000} /> : null }
        <GroupInfoPanel
          title={title}
          updateTitle={(title: string) => this.setState({ title: title, titleError: '' })}
          description={description}
          updateDescription={(description: string) => this.setState({ description: description, descriptionError: '' })}
          heroImage={heroImage}
          updateHeroImage={(heroImage: HeroImageData|null) => this.setState({ heroImage: heroImage })}
          titleError={titleError}
          descriptionError={descriptionError}
        />
      </div>
    )
  }
}

export default GroupAdd
